import { Component, OnInit } from '@angular/core';
import { SelectProfileComponent } from '../select-profile/select-profile.component';
import { BaseService } from '../../shared/services/base.service';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { StorageService } from '../../shared/services/storage.service';
import { AlertsService } from '../../services/alerts.service';
import { SmartModalService } from '../../services/smart-modal.service';
import { DialogRef } from '../dialog/dialog-ref';
import { DialogService } from '../dialog/dialog.service';
import { LoaderService } from '../../services/loader.service';
import { UtilService } from '../../services/util.service';
import { AppService } from '../../shared/services/app.service';

@Component({
    selector: 'kx-select-profile-extended',
    templateUrl: './select-profile-extended.component.html',
    styleUrls: ['./select-profile-extended.component.scss'],
    standalone: false
})
export class SelectProfileExtendedComponent extends SelectProfileComponent implements OnInit {
  filterKey:any="";

  constructor(
    public baseService: BaseService,
    public appService: AppService,
    public autheticationService:AuthenticationService,
    public storageService: StorageService,
    public alertService: AlertsService,
    public loaderService: LoaderService,
    public smartModalService: SmartModalService,
    public dialogRef: DialogRef,
    public dialogService: DialogService,
    private util: UtilService
  ) { 
    super(baseService,appService,autheticationService,storageService,alertService,loaderService,smartModalService,dialogRef,dialogService)
  }

  onSearchKey(event){
    
  }

  openpopup(){
    if(this.util.isMobile()){
      super.openpopup();
    }
  }

}
